import { AnimatePresence, motion } from 'framer-motion';
import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { toSeconds, useMotion } from './motion-provider';

const RISE_PX = 8;

/**
 * Cross-fades route changes inside the module. Keyed on the pathname so a
 * query-string change (e.g. `?tab=`) does not re-animate the page.
 * `exitBeforeEnter` is framer-motion 6's name for what 7+ calls `mode="wait"`.
 */
export const PageTransition = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => {
  const { pathname } = useLocation();
  const { durations, prefersReducedMotion } = useMotion();
  const rise = prefersReducedMotion ? 0 : RISE_PX;

  return (
    <AnimatePresence initial={false} exitBeforeEnter>
      <motion.div
        key={pathname}
        data-reduced-motion={prefersReducedMotion}
        initial={{ opacity: 0, y: rise }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0 }}
        transition={{ duration: toSeconds(durations.medium), ease: 'easeOut' }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};
